import Vue from 'vue'
import Plugin from './plugin'

const hotelVendors = Object.freeze([
  { 'trvNum': '3', 'name': '雄獅旅遊', 'shortName': 'lion', 'logo': 'logo_lion.png' },
  { 'trvNum': '4', 'name': '可樂旅遊', 'shortName': 'cola', 'logo': 'logo_cola.png' },
  { 'trvNum': '14', 'name': 'Expedia Affiliate Network', 'shortName': 'ean' },
  { 'trvNum': '16', 'name': 'AsiaYo', 'shortName': 'asiayo', 'trvCode': 'V35' }
])

const tourVendors = Object.freeze([
  {'trvNum': '2', 'name': '東南旅遊', 'shortName': '東南', 'logo': 'logo_settour.png'},
  // {'trvNum': '3', 'name': '雄獅旅遊', 'shortName': '雄獅', 'logo': 'logo_lion.png'},
  {'trvNum': '4', 'name': '可樂旅遊', 'shortName': '可樂', 'logo': 'logo_cola.png'},
  {'trvNum': '8', 'name': '鳳凰旅遊', 'shortName': '鳳凰', 'logo': 'logo_phoenix.png'},
  {'trvNum': '12', 'name': '五福假期', 'shortName': '五福', 'logo': 'logo_lifetour.png'},
  {'trvNum': '13', 'name': '長汎旅遊', 'shortName': '長汎', 'logo': 'logo_everfun.jpg'},
  {'trvNum': '17', 'name': '喜鴻旅遊', 'shortName': '喜鴻', 'logo': 'logo_besttour.jpg'},
  {'trvNum': '29', 'name': '百威旅遊', 'shortName': '百威', 'logo': 'logo_bestway.png'}

])

var CommonService = function () {
  this.source = null
}

CommonService.prototype.fetchNewHeader = function () {
  return new Promise((resolve, reject) => {
    Vue.axios.get('/m/newHeader', { responseType: 'text', showSpinner: false })
      .then(response => {
        resolve(response)
      })
      .catch(error => {
        reject(error)
      })
  })
}

CommonService.prototype.getAllHotelVendors = function () {
  return $.extend(true, [], hotelVendors)
}

CommonService.prototype.getAllTrvNums = function () {
  return this.getAllTrvNumsArray().join()
}

CommonService.prototype.getAllTourTrvNums = function () {
  return this.getAllTourTrvNumsArray().join()
}

CommonService.prototype.getAllTrvNumsArray = function () {
  return $.map(hotelVendors, function (vendor) {
    return vendor['trvNum']
  })
}

CommonService.prototype.getAllTourTrvNumsArray = function () {
  return $.map(tourVendors, function (vendor) {
    return vendor['trvNum']
  })
}

CommonService.prototype.getHotelVendorByTrvNum = function (trvNum) {
  var results = $.grep(hotelVendors, function (vendor) {
    return vendor.trvNum === trvNum.toString()
  })

  return results.length === 0 ? '' : results[0]
}

CommonService.prototype.getHotelVendorByShortName = function (shortName) {
  var results = $.grep(hotelVendors, function (vendor) {
    return vendor.shortName === shortName
  })

  return results.length === 0 ? '' : results[0]
}

Vue.use(Plugin, new CommonService())



// WEBPACK FOOTER //
// ./src/services/common-service/index.js